import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from "@angular/material/button";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";


@Component({
    selector: 'app-http-error',
    imports: [
        MatButton,
        TranslatePipe
    ],
    templateUrl: './http-error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './http-error.component.css'
})
export class HttpErrorComponent {
  @Input("header") header: string
  @Input("http-error") errorCode: string
  @Input("body") body: string

  constructor(private router: Router) {
  }

  returnToHome() {
    this.router.navigateByUrl('/')
  }

}
